import { app } from '../../../app';
import { Controller } from './saaspass-connect-login.controller';

app.component('publicSaaspassConnectLogin', {
    templateUrl: require('./saaspass-connect-login.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/saaspass-connect-login/saaspass-connect-login.component.js